import { TrendingDownIcon, TrendingUpIcon } from 'lucide-react';

import { useTranslation } from '@splitfiesta/i18n';
import { isEffectivelyZero } from '@splitfiesta/shared';
import type { GroupWithDashboard } from '@splitfiesta/shared';
import { StatCard } from '@splitfiesta/ui';

import { CurrencyDisplay } from '@/components/ui/CurrencyDisplay';

interface UserBalanceCardProps {
  group: GroupWithDashboard;
  userBalance: number;
}

export function UserBalanceCard({ group, userBalance }: UserBalanceCardProps) {
  const { t } = useTranslation();

  const isZero = isEffectivelyZero(userBalance, group?.currency || 'USD');
  const isPositive = userBalance > 0;

  return (
    <div data-testid="your-balance-card">
      <StatCard
        icon={
          isPositive ? (
            <TrendingUpIcon className="w-8 h-8" />
          ) : isZero ? (
            <TrendingUpIcon className="w-8 h-8" />
          ) : (
            <TrendingDownIcon className="w-8 h-8" />
          )
        }
        iconColor={
          isZero
            ? 'text-gray-400'
            : isPositive
              ? 'text-green-600 dark:text-green-400'
              : 'text-red-600 dark:text-red-400'
        }
        label={t('groups:stats.yourBalance')}
        value={
          isZero ? (
            <>
              <div className="text-xl font-bold">
                {t('common:labels.settled')}
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {t('groups:stats.noBalance')}
              </div>
            </>
          ) : (
            <>
              <div
                className={`text-xl font-bold ${
                  isPositive
                    ? 'text-green-600 dark:text-green-400'
                    : 'text-red-600 dark:text-red-400'
                }`}
              >
                {isPositive ? '+' : '-'}
                <CurrencyDisplay
                  amount={Math.abs(userBalance)}
                  currency={group?.currency || 'USD'}
                />
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {group?.currency || 'USD'}
              </div>
            </>
          )
        }
      />
    </div>
  );
}
